export default "__VITE_ASSET__BYlib17d__"